import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  constructor(
    private _snackBar: MatSnackBar,
    private _translate: TranslateService) {
  }

  show(messageKey: string, action: string = 'Close', duration: number = 5000) {
    this._translate.get(messageKey).subscribe((translatedMessage: string) => {
      this._snackBar.open(translatedMessage, action, {
        duration: duration,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    });
  }
}
